module.exports = __webpack_public_path__ + "static/media/view.e1de5933.svg";